<script lang="ts" setup>
import { computed } from "vue";
import dayjs from 'dayjs';
import {useI18n} from 'vue-i18n';
import {formatDate} from '@/models/utils/dateUtils';
import MvButton from "@/components/common/button/MvButton.vue";
import {showNtfc} from "@/script/common/popupScript";
import {resendQpassAlimtalkApi} from '@/api/nftApis';

const props = defineProps({
  nftId: {
    default: 0
  },
  status: {
    default: "",
  },
  type: {
    default: "MEMBERSHIP",
  },
  openDate: {
    default: '',
  },
  timeZone: {
    default: '',
  },
  isQpass: {
    default: false
  }
})
const { locale } = useI18n()
dayjs.locale(locale.value)
const openDateTxt = computed(() => {
  return formatDate(props.openDate, {
    format: 'lll',
    timeZone: props.timeZone,
  })
})

const resendQpass = async () => {
  await resendQpassAlimtalkApi(props.nftId)
  showNtfc('입장권이 모바일로 재전송되었습니다.')
}
</script>

<template>
  <div class="qr-status-comp">
    <div v-if="isQpass" class="status-row event-lock">
      <img src="@/assets/images/card/lock_white.svg" alt="Lock Image" class="lock-icon mb-8"/>
      <p class="title-text mb-16">{{ $t('nftCard.qpass.sent') }}</p>
      <p class="desc-text">
        <MvButton
          :text="$t('common.resend')"
          type="rec-primary"
          @click.stop="resendQpass"
      />
      </p>
      <div class="back-image-area">
        <img src="@/assets/images/pictures/qr_image.png" alt="QR Image" class="back-image" />
      </div>
    </div>
    <div v-else-if="status === 'ticketLock'" class="status-row status-lock">
      <img src="@/assets/images/icons/lock_color.png" alt="Lock Image" />
      <p>{{ $t("nftCard.status.TICKET.lock") }}</p>
      <div class="back-image-area">
        <img src="@/assets/images/pictures/qr_image.png" alt="QR Image" class="back-image" />
      </div>
    </div>
    <div v-else-if="status === 'beforeOpen'" class="status-row event-lock">
      <img src="@/assets/images/card/lock_white.svg" alt="Lock Image" class="lock-icon mb-8"/>
      <p class="title-text mb-16">{{ $t("nftCard.eventLock.title") }}</p>
      <p class="desc-text">{{ $t("nftCard.eventLock.activeTime") }}<br>{{ openDateTxt }}</p>
      <div class="back-image-area">
        <img src="@/assets/images/pictures/qr_image.png" alt="QR Image" class="back-image" />
      </div>
    </div>
    <div v-else class="status-row status-used" :class="`type-${type}`">
      <img src="@/assets/images/icons/used_mark.png" alt="Used Image" />
      <p>{{ $t(`nftCard.status.${type}.${status}`) }}</p>
    </div>
  </div>
</template>

